import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, Menu, MenuItem, IconButton, ListItemIcon, ListItemText} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

//import { sortByName } from '../../../api/helpers';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
//import { PERMISSIONS } from '../../api/ServerApi';



class ServerLinksList_ extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            //licenses: this.props.licenses,
            menuAnchor: null, 
            menuItem: '',
            //selected: ''
        }

    }

    handleItemSelect(id){
        //this.setState({selected: id})
        this.props.onAction({type: 'SELECT_CURRENT_SERVER', externalServerID: id})
    }

    getRowStyle(id){
        //let selected = id === this.state.selected
        //console.log('getRowStyle '+id + ' =? '+ this.props.currentServerID)
        let selected = id === this.props.currentServerID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, linkID){
        this.setState({menuAnchor: event.currentTarget, menuItem: linkID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null, menuLicense: null});
        return null;
    }

    handleMenuItemClick(menu, linkID){
        linkID = linkID ? linkID : this.state.menuItem
        this.handleMenuClose();
        this.props.onContextMenu(menu, linkID)
    }

    checkPermission(permission){
        return this.props.onAction({
            type:'CHECK_PERMISSION', 
            permission: permission 
        })
    }

    render(){
        const {t} = this.props

        //console.log('render Server Links List')
        //console.log(this.props)

        //this.state.licenses.sort(sortByName)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={1} style={styles.head}>{t('Name')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('IPEndpoint')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('Active')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('ExternalLogin')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('LocalLogin')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('State')}</TableCell>

                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        onClick={()=>{this.handleMenuItemClick('SERVER_LINK_EDITOR_OPEN_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {this.props.linkedServers.map((externalServer) => 
                            <TableRow key={externalServer.ServerLink.ID} 
                                    onClick={()=>{this.handleItemSelect(externalServer.ServerLink.ID)}}
                                    onDoubleClick={()=>{this.handleMenuItemClick('SERVER_LINK_EDITOR_OPEN_EDIT', externalServer.ServerLink.ID)}}
                                    style={this.getRowStyle(externalServer.ServerLink.ID)}>

                                <TableCell component="th" scope="row">
                                    {externalServer.ServerLink.ExternalName}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {externalServer.ServerLink.IPEndpoint}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {externalServer.ServerLink.LinkState? <CheckBox/> : <CheckBoxOutlineBlank/>}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {externalServer.ServerLink.ExternalLogin}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {externalServer.ServerLink.LocalLogin}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {externalServer.ServerLink.ConnectState? t('Connected') : t('Disconnected')}
                                </TableCell>

                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="more" component="span"
                                        onClick={event=>this.handleMenuClick(event, externalServer.ServerLink.ID)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                                
                            </TableRow>
                        )}
                        </TableBody>

                        <Menu anchorEl={this.state.menuAnchor} keepMounted
                            open={Boolean(this.state.menuAnchor)} 
                            onClose={this.handleMenuClose.bind(this)}>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('SERVER_LINK_EDITOR_OPEN_EDIT')}}>
                                <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                                <ListItemText primary={t('EditExternalWFServer')+'...'} />
                            </MenuItem>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('SERVER_LINK_DELETE')}}>
                                <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                                <ListItemText primary={t('DeleteExternalWFServer')} />
                            </MenuItem>
                            {/*<MenuItem onClick={()=>{this.handleMenuItemClick('properties')}}>Properties...</MenuItem>*/}
                        </Menu>

                    </Table>
                </Paper>
            </>
        )

    }

}

export const ServerLinksList = withTranslation()(ServerLinksList_);